import styled from 'styled-components';

import { mainGridGapColor } from '#/colors';

import {
  useUserPreferencesActions,
  useUserPreferencesView,
} from '#/features/user-preferences/user-preferences-context';
import { useTranslation } from '#/features/localization/utils';

import Toggle from '#/components/common/Toggle';

export default function NotificationsDrawerSettingsMenu() {
  const userPreferencesView = useUserPreferencesView();
  const userPreferencesActions = useUserPreferencesActions();
  const { t } = useTranslation();

  return (
    <Container>
      <Label>
        <LabelText>{t('Display Toast Notifications')}</LabelText>
        <Toggle
          checked={userPreferencesView.isToastDisplayEnabled}
          onChange={(event) => {
            userPreferencesActions.updateToastDisplay(event.target.checked);
          }}
        />
      </Label>
    </Container>
  );
}

const Container = styled.div`
  padding: 16px;
  border-bottom: 1px solid ${mainGridGapColor};
`;

const Label = styled.label`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: 6px;
  cursor: pointer;
`;

const LabelText = styled.span`
  opacity: 0.7;
  font-size: 12px;
  font-weight: 500;
`;
